import React, { Component } from "react";
import NewAuditTrail from "../../2/Controls/NewAuditTrail";

class ProductAuditTrial extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tableData: [],
            loading: false,
        };
    }

    componentDidMount() {
        const { productData } = this.props;

        if (productData.key) {
            this.fetchData(productData.key);
        }
    }

    fetchData = async (key) => {
        this.setState({ loading: true });

        try {
            const data = await this.props.getProductAuditTrail(key);

            console.log("data in Audit trail ", data);

              this.setState({
            tableData: Array.isArray(data.product) ? data.product : [data.product],
        });
        } catch (error) {
            console.log("error",error);
            alert("Failed to load data !");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { tableData, loading } = this.state;

        return (
    <div style={{ padding: "4px" }}>
                <NewAuditTrail data={tableData} loading={loading} />
            </div>
        );
    }
}

export default ProductAuditTrial;